import { actions } from './action'
import { mutations } from './mutations'
import { getters } from "./getters";

const state = {
    usuarioLogadoNoSistema: undefined,
    perfil: undefined,
    matriculas: undefined,
    modulos: undefined
};

const namespaced = true;

export const gateway = {
    namespaced,
    state,
    actions,
    getters,
    mutations
};

